import { createContext } from "react";

export type RadioGroupContextType = {
  value: string | undefined;
  onChange: (value: string) => void;
  isDisabled?: boolean;
};

export const RadioGroupContext = createContext<RadioGroupContextType | null>(
  null
);
